// @flow
import * as React from 'react';
import {useHistory} from 'react-router-dom';
import styled from 'styled-components';
import {LayoutLeftTop} from 'components/Layout';
import Icon from 'assets/images/home/img-kia-logo.svg';

type Props = {
}

export default function Logo(props: Props): React.Element<any> {
  const history = useHistory();
  
  return (
    <DivLogo {...props}>
      <button onClick={() => history.push('/welcome')}><img src={Icon} alt="logo" /></button>
    </DivLogo>
  );
}

const DivLogo = styled(LayoutLeftTop)`
  img {
    width: ${(props) => (props.theme.layout.mobile ? 44 : 70)}px;
    height: ${(props) => (props.theme.layout.mobile ? 10 : 16)}px;
    padding: ${(props) => (props.theme.layout.mobile ? 24 : 49)}px
      ${(props) => (props.theme.layout.mobile ? 30 : 80)}px;
  }
`;
